var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-uploader',{attrs:{"max-count":1,"max-size":1024 * 1000 * 10,"accept":'image/*',"after-read":_vm.onRead},on:{"oversize":_vm.onOversize},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}},[(_vm.defaultSrc)?_c('van-image',{ref:"img",attrs:{"src":_vm.defaultSrc}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }